import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '../../i18n';
import { usePreferences } from '../../contexts/PreferencesContext';
import { CheckCircle } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';

export function PaymentSuccess() {
    const { t } = useTranslations();
    const navigate = useNavigate();
    const { preferences } = usePreferences();
    const queryClient = useQueryClient();

    // Trigger full state refresh on mount
    useEffect(() => {
        // Invalidate queries so user preferences and usage are reloaded
        queryClient.invalidateQueries();
    }, [queryClient]);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-slate-950 p-6 text-center z-50">
            <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-3xl p-8 space-y-6 shadow-2xl">
                <div className="flex justify-center">
                    <div className="w-16 h-16 bg-green-900/30 rounded-full flex items-center justify-center text-green-400 animate-bounce">
                        <CheckCircle size={40} />
                    </div>
                </div>
                
                <div className="space-y-2">
                    <h2 className="text-3xl font-black text-white">
                        {t.settings.upgradeSuccessTitle || 'Upgraded successfully!'}
                    </h2>
                    <p className="text-slate-400 text-sm">
                        {t.settings.upgradeSuccessDesc || 'Thank you for upgrading! Your account has been upgraded to Pro.'}
                    </p>
                </div>

                <div className="bg-slate-800/30 border border-slate-800 rounded-2xl p-4 text-left">
                    <div className="flex justify-between items-center">
                        <span className="text-xs text-slate-500 font-bold uppercase tracking-wider">Plan</span>
                        <span className="bg-green-500 text-slate-950 text-[10px] px-2.5 py-1 rounded-full uppercase tracking-widest font-black">
                            PRO
                        </span>
                    </div>
                </div>

                <div className="pt-2">
                    <button
                        onClick={() => navigate('/settings')}
                        className="w-full py-4 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold transition-all shadow-lg shadow-blue-500/20"
                    >
                        {t.common.ok || 'OK'}
                    </button>
                </div>
            </div>
        </div>
    );
}
